import { render } from "./Avatar.vue?vue&type=template&id=40d52df1"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=40d52df1&lang=css"

import exportComponent from "C:\\Dev\\Perso\\vue-upload-component\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__